module.exports = __webpack_public_path__ + "img/playground.551071d1.jpg";